// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__NhSq1","label":"TextInput_label__qnZMm"};